import { Button, Typography } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 64px;
`

export const PrintingDetails = styled.div`
    padding-left: 16px;
    border-left: 8px solid ${theme.colors.green2};
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const InvoicesCount = styled(Typography)``

export const Observation = styled(Typography)``

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
`

export const PrintButton = styled(Button)`
    background: ${theme.colors.blue} !important;
`

export const NextButton = styled(Button)`
    background: ${theme.colors.green2} !important;

    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const SaveButton = styled(Button)`
    background: ${theme.colors.blue} !important;

    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const PrintArea = styled.div`
    display: none;

    @media print {
        display: block;
    }
`
